module.exports = __webpack_public_path__ + "static/media/prylpoolen-image.c18f3dfb.png";